import { formattedPrice, formattedPriceForJapan } from "./FormattedPrice";

const customSymbols: { [key: string]: string } = {
  DKK: "kr", // Danish Krone
  SEK: "kr", // Swedish Krona
  NOK: "kr", // Norwegian Krone
  CHF: "CHF", // Swiss Franc
  EUR: "€", // Euro
  GBP: "£", // British Pound
  NZD: "$", // New Zealand Dollar
  USD: "$", // US Dollar
  CAD: "$", // Canadian Dollar
  SGD: "$", // Singapore Dollar
  AUD: "$", // Australian Dollar
  JPY: "¥", // Japanese Yen
  CNY: "¥", // Chinese Yuan
};
export const priceWithCurrency = (currency: string, price: string | number) => {
  // Check if the currency has a custom symbol defined
  const currencySymbol = customSymbols[currency] || currency;
  const newPrice: string = formattedPrice(price);
  const priceWithSymbol = `${currencySymbol}${currencySymbol.length > 1 ? " ": ""}${newPrice}`;
  return priceWithSymbol;
};

export const priceWithCurrencyForJapan = (currency: string, price: string | number) => {
  // Check if the currency has a custom symbol defined
  const currencySymbol = customSymbols[currency] || currency;
  const newPrice: string = formattedPriceForJapan(price);
  const priceWithSymbol = `${currencySymbol}${currencySymbol.length > 1 ? " ": ""}${newPrice}`;
  return priceWithSymbol;
};

export const symbolForCurrency = (currency: string) => {
  return customSymbols[currency] || currency;
};